// extracted by mini-css-extract-plugin
export default {"container":"Users_container__extqf","container2":"Users_container2__tL9G4","users":"Users_users__D65Fr","img":"Users_img__M0sAE","arrow":"Users_arrow__zOE-C"};